import angular from 'angular';
import TableContainerComponent from './table-container.component';

const TableContainerModule = angular
    .module('control-room.commons.layout.components.table-container', [])
    .component('crTableContainer', TableContainerComponent);

export default TableContainerModule;
